// extracted by mini-css-extract-plugin
export default {"reportLayout":"cluster-report-layout-module__reportLayout--ZCyuU","report":"cluster-report-layout-module__report--wOd3Q"};